import ExpertFormModal from './form-modal';
import GetExpertButton from './get-expert-button';

export const Expert = {
  Button: GetExpertButton,
  Form: ExpertFormModal,
};
